import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { UserPlus, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", email: "", phone: "" };

export const CustomerFormDialog = ({ open, onOpenChange, customer, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const editing = !!customer;

  useEffect(() => {
    if (!open) return;
    setForm(customer ? { name: customer.name || "", email: customer.email || "", phone: customer.phone || "" } : EMPTY);
  }, [open, customer]);

  const save = async () => {
    if (form.name.trim().length < 2) { toast.error("Escribe el nombre del cliente"); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { toast.error("Correo inválido"); return; }
    if (form.phone.trim().length < 6) { toast.error("Teléfono inválido"); return; }
    setSaving(true);
    const payload = { name: form.name.trim(), email: form.email.trim(), phone: form.phone.trim() };
    try {
      const res = editing
        ? await api.put(`/customers/${customer.id}`, payload)
        : await api.post("/customers", payload);
      toast.success(editing ? "Cliente actualizado" : "Cliente agregado");
      onSaved?.(res.data, editing);
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo guardar el cliente");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="customer-form-dialog" className="max-w-md rounded-2xl">
        <DialogHeader><DialogTitle className="font-display">{editing ? "Editar cliente" : "Agregar cliente"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs text-neutral-500">Nombre</Label>
            <Input data-testid="customer-form-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Nombre y apellido" className="rounded-xl mt-1" />
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Correo</Label>
            <Input data-testid="customer-form-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="cliente@correo.com" className="rounded-xl mt-1" />
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Teléfono</Label>
            <Input data-testid="customer-form-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
              placeholder="8888 8888" className="rounded-xl mt-1" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="rounded-xl">Cancelar</Button>
          <Button data-testid="save-customer-btn" onClick={save} disabled={saving} className="rounded-xl gap-2 bg-[#00AEEF] hover:bg-[#0092CC] text-white">
            {saving ? <Loader2 size={16} className="animate-spin" /> : (editing ? <Save size={16} /> : <UserPlus size={16} />)}
            {editing ? "Guardar cambios" : "Guardar cliente"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
